import script from "./pointsManage.vue?vue&type=script&setup=true&lang=js"
export * from "./pointsManage.vue?vue&type=script&setup=true&lang=js"

import "./pointsManage.vue?vue&type=style&index=0&id=70ac5a4e&lang=scss"

const __exports__ = script;

export default __exports__